/**
 * 此文件已迁移到共享包 @hz/shared/const/image
 * 为保持向后兼容性，此处重新导出共享包的内容
 */
module.exports = require('@hz/shared/const/image')
